export default "__VITE_ASSET__CBdbUiMF__"